import styled from 'styled-components'

export const Container = styled.table`
margin-top: 1rem;
border-spacing: 0 .5rem;
font-family: 'Roboto','sans-serif';
thead{
    tr{
        color: var(--a2);
        font-weight: 600;
        font-size: 1rem;
    }
}


tbody{

    tr{
        background-color: var(--c2);
        & td {
            padding: 1rem;
        }

        .tdCenter{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    tr,th{
        border-collapse: collapse;
        padding: .5rem;
    }

    ul{
        width: fit-content;
    }
}
`
